type Node<T> = {
    id: symbol;
    value: T;
    idx: number;
    next?: Node<T>;
};

export { type Node as SequenceNode };

export class Sequence<T> {
    public head?: Node<T>;
    public length = 0;

    constructor(items: T[]) {
        if (items.length === 0) {
            throw new Error("Cannot initialize a Sequence with an empty list");
        }

        let prevNode: Node<T> | undefined;
        for (let idx = items.length - 1; idx >= 0; --idx) {
            const value = items[idx];
            const node: Node<T> = {
                id: Symbol("sequence_node"),
                idx,
                value,
                next: prevNode,
            };
            this.head = node;
            ++this.length;
            prevNode = node;
        }
    }

    public *iterate(): Generator<Node<T>, void, undefined> {
        let curr = this.head;
        while (curr != null) {
            yield curr;
            curr = curr.next;
        }
    }

    public forEach(cb: (value: T) => void) {
        for (const node of this.iterate()) {
            cb(node.value);
        }
    }

    public reduce<AccType>(
        cb: (acc: AccType, curr: T) => AccType,
        initialValue: AccType,
    ) {
        let res: AccType = initialValue;
        this.forEach((value) => {
            res = cb(res, value);
        });

        return res;
    }

    public toArray(): T[] {
        const values: T[] = [];
        for (const node of this.iterate()) {
            values.push(node.value);
        }
        return values;
    }

    public toMap(getKeyFn: (value: T) => string): Map<string, T> {
        const map = new Map<string, T>();
        for (const node of this.iterate()) {
            const key = getKeyFn(node.value);
            map.set(key, node.value);
        }
        return map;
    }
}
